import { register } from "async-ops";
import { callMvcApi } from "../../../../call-web-api";
export const MARK_DOCUMENT_AS_ARCHIEVE = "MARK_DOCUMENT_AS_ARCHIEVE";

export const service = async (data) => {
  const options: object = {
    url: "/api/EMDR/MarkDocumentAsArchieveUnArchieve",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(data),
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(MARK_DOCUMENT_AS_ARCHIEVE, service, mock);
